/*
  Hoofdnavigatie desktop (snippets/mega-menu.liquid): openen bij hover met de
  muis, sluiten met Escape of door buiten het menu te klikken of te focussen.
  Werkt met elk aantal <details data-aza-nav-root>. Zonder dit script werken
  de panelen gewoon als <details> op klik. Dit is de enige kopie; het inline
  script in mega-menu.liquid is weg (upgrade NZ-01).
*/
(() => {
  if (window.__azaNavV2Initialized) return;
  const nav = document.querySelector('.aza-nav-v2');
  if (!nav) return;
  window.__azaNavV2Initialized = true;

  const roots = [...nav.querySelectorAll('[data-aza-nav-root]')];
  let closeTimer;
  let hoverOpened = null;
  const closeAll = (except) => roots.forEach((root) => {
    if (root !== except) root.open = false;
  });

  roots.forEach((root) => {
    const summary = root.querySelector('summary');
    summary?.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(closeTimer);
      closeAll(root);
      if (!root.open) hoverOpened = root;
      root.open = true;
    });
    // Wie met de muis naar een item gaat, opent het al bij hover; de klik die
    // daarop volgt mag het paneel dan niet weer dichtklappen.
    summary?.addEventListener('click', (event) => {
      if (hoverOpened === root && root.open) event.preventDefault();
      hoverOpened = null;
    });
    root.addEventListener('pointerenter', () => clearTimeout(closeTimer));
    root.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse') return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => { if (!root.matches(':focus-within')) root.open = false; }, 140);
    });
    root.addEventListener('toggle', () => { if (root.open) closeAll(root); });
  });

  // Een directe link (Hydrosolen) sluit een open paneel bij hover.
  nav.querySelectorAll('.aza-nav-v2__direct').forEach((link) => {
    link.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'mouse') closeAll();
    });
  });

  nav.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openRoot = roots.find((root) => root.open);
    closeAll();
    openRoot?.querySelector('summary')?.focus();
  });
  document.addEventListener('pointerdown', (event) => {
    if (!nav.contains(event.target)) closeAll();
  });
  document.addEventListener('focusin', (event) => {
    if (!nav.contains(event.target)) closeAll();
  });
  nav.classList.add('is-ready');
})();
